import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
    selector: 'sd-eng-banner',
    templateUrl: './eng-banner.component.html',
    styleUrls: ['./eng-banner.component.scss']
})

export class EngBannerComponent implements OnInit {

    adsLoaded: Boolean = false;
    ad: any;

    showAd: Boolean = false;

    constructor(
        public api: ApiService,
        public global: GlobalService,
        public router: Router
    ) {
        this.advetisement();
    }

    ngOnInit() {
    }

    advetisement() {
        this.api.advertisement('engangement').subscribe(res => {
            console.log(res);
            this.adsLoaded = true;

            if ( res.success && res.result.length>0 ) {
                res.result.forEach(ad => {
                    if ( ad.adv_display_pages.includes('spotlight') && this.router.url.split('?')[0] == '/what-is-new' ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('song_list') && (this.router.url.split('?')[0] == '/songs' || this.router.url.split('?')[0].indexOf('/songs/') !== -1) ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('video_list') && (this.router.url.split('?')[0] == '/video-songs' || this.router.url.split('?')[0].indexOf('/video-songs/') !== -1) ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('opportunities_list') && this.router.url.split('?')[0] == '/opportunities' ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('upload_tracks') && (this.router.url.split('?')[0] == '/upload/song' || this.router.url.split('?')[0] == '/upload/tracks') ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('upload_albums') && (this.router.url.split('?')[0] == '/upload/album' || this.router.url.split('?')[0] == '/upload/tracks') ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('upload_videos') && (this.router.url.split('?')[0] == '/upload/video' || this.router.url.split('?')[0] == '/upload/videos' || this.router.url.split('?')[0] == '/upload/tracks') ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('my_opportunities_detail') && this.router.url.split('?')[0] == '/mydashboard/opportunities' ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('my_music_detail') && (this.router.url.split('?')[0] == '/mydashboard/songs' || this.router.url.split('?')[0] == '/mydashboard/albums' || this.router.url.split('?')[0] == '/mydashboard/videos') ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('playlists_list') && (this.router.url.split('?')[0] == '/playlists') ) {
                        this.ad = ad;
                        this.showAd = true;
                    }
                });


                /*
                } else if ( this.ad.adv_display_pages.includes('tv') && this.router.url.indexOf('songdew-tv') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('artist_dashboard') && this.router.url.indexOf('mydashboard') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('playlists_list') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('opportunities_list') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('user_feed') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('artists_list') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('analytics_detail') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('my_opportunities_detail') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('achievements_detail') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('my_music_detail') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } */
            }
        },
        (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
                // console.log('Client-side error occured!');
            } else {
                // console.log('Server-side error occured!', err);
            }
        });
    }
}
